import { createSelector } from '@ngrx/store';
import { getAuthenticationState } from '../reducers';

export const IsApplicantLoggedIn = createSelector(
  getAuthenticationState,
  state => state.isApplicantLoggedIn
);

export const IsUserLoggedIn = createSelector(
  getAuthenticationState,
  state => state.isUserLoggedIn
);

export const LoggedInApplicant = createSelector(
  getAuthenticationState,
  state => state.applicant
);

export const AuthenticationToken = createSelector(
  getAuthenticationState,
  state => state.applicantToken
);

export const AuthenticationExpresAt = createSelector(
  getAuthenticationState,
  state => state.applicantExpiresAt
);

export const LoggedInUser = createSelector(
  getAuthenticationState,
  state => state.user
);

//export const Permissions = createSelector(
//  getAuthenticationState,
//  getLookupState,
//  (authenticationState, lookupState) => {
//    let roles: Role[] = Object.values(authenticationState.userRoles);
//    let rolePermissions: RolePermission[] = Object.values(lookupState.rolePermission);
//    let permissions: Permission[] = [];
//    roles.forEach(r => {
//      let permissionsForARole: Permission[] = rolePermissions?.filter(p => p.role.id == r.id)?.map(rp => rp.permission);
//      permissionsForARole.forEach(p => {
//        if (!permissions?.find(per => p.id == per.id)) {
//          permissions.push(p);
//        }
//      })
//    })
//    return permissions;
//  }
//);





